import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import './styles/global.scss';
import { createRoot } from 'react-dom/client';
import { AppTop } from './app/appTop';
import { registerServiceWorker } from './utils/serviceWorker/registerServiceWorker';
function initReact() {
    const domNode = document.querySelector('.app');
    if (!domNode) {
        return;
    }
    const root = createRoot(domNode);
    root.render(_jsx(AppTop, {}));
}
initReact();
registerServiceWorker();
